export default "__VITE_ASSET__CpYH$rmV__"